import { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { CheckCircle, Mail, FileText } from 'lucide-react';
import { Button } from '../components/ui/button';
import { Card, CardContent } from '../components/ui/card';

export default function Formulario2Exitoso() {
  const navigate = useNavigate();
  const location = useLocation();
  const expedienteNumero = location.state?.expedienteNumero;

  useEffect(() => {
    // Si no hay datos, redirigir
    if (!expedienteNumero) {
      navigate('/formulario-1');
    }
  }, [expedienteNumero, navigate]);

  if (!expedienteNumero) {
    return null;
  }

  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-900 via-gray-800 to-black flex items-center justify-center py-12 px-6">
      <div className="max-w-2xl w-full">
        {/* Logo */}
        <div className="text-center mb-8">
          <img src="/kompa-logo.png" alt="Kompa" className="h-16 w-auto mx-auto mb-4" />
        </div>

        {/* Card principal */}
        <Card className="bg-gray-800/50 backdrop-blur-xl border-gray-700">
          <CardContent className="p-8 text-center">
            {/* Icono de éxito */}
            <div className="mb-6">
              <div className="w-20 h-20 bg-green-500/20 rounded-full flex items-center justify-center mx-auto">
                <CheckCircle className="w-12 h-12 text-green-500" />
              </div>
            </div>

            {/* Título */}
            <h1 className="text-3xl font-bold text-white mb-3">
              ¡Formulario Recibido Exitosamente!
            </h1>
            
            <p className="text-gray-400 text-lg mb-8">
              Hemos recibido tu Formulario 2 con toda la información requerida
            </p>

            {/* Detalles */}
            <div className="bg-gray-900/50 rounded-xl p-6 mb-8 text-left">
              <h2 className="text-white font-semibold mb-4 text-center">Información del Expediente</h2>
              
              <div className="space-y-3">
                <div className="flex items-center gap-3">
                  <FileText className="w-5 h-5 text-yellow-500" />
                  <div>
                    <p className="text-gray-400 text-sm">Número de Expediente</p>
                    <p className="text-white font-medium">{expedienteNumero}</p>
                  </div>
                </div>
              </div>
            </div>

            {/* Mensaje de email */}
            <div className="bg-blue-900/20 border border-blue-500/30 rounded-lg p-5 mb-8">
              <div className="flex items-start gap-3">
                <Mail className="w-6 h-6 text-blue-400 flex-shrink-0 mt-1" />
                <div className="text-left">
                  <p className="text-white font-semibold mb-2">Revisa tu correo electrónico</p>
                  <p className="text-gray-300 text-sm">
                    Te hemos enviado un email de confirmación con los detalles de tu solicitud.
                  </p>
                  <p className="text-gray-400 text-xs mt-2">
                    Si no lo ves en tu bandeja de entrada, revisa la carpeta de spam.
                  </p>
                </div>
              </div>
            </div>

            {/* Próximos pasos */}
            <div className="text-left bg-gray-900/30 rounded-lg p-5 mb-8">
              <h3 className="text-white font-semibold mb-3 text-center">📋 Próximos Pasos</h3>
              <ol className="text-gray-300 text-sm space-y-2 list-decimal list-inside">
                <li>Nuestro equipo gerencial revisará tu documentación</li>
                <li>Calcularemos el monto de tu reembolso</li>
                <li>Te enviaremos los documentos para firma</li>
                <li>Procesaremos tu pago según la fecha acordada</li>
              </ol>
            </div>

            {/* Información adicional */}
            <div className="text-gray-400 text-sm space-y-2 mb-8">
              <p>• Te mantendremos informado/a de cada paso del proceso</p>
              <p>• Si tienes alguna pregunta, no dudes en contactarnos</p>
            </div>

            {/* Botón de acción */}
            <Button
              onClick={() => window.close()}
              className="w-full bg-yellow-500 hover:bg-yellow-600 text-black font-semibold"
            >
              Cerrar Ventana
            </Button>
          </CardContent>
        </Card>

        {/* Mensaje de soporte */}
        <p className="text-center text-gray-500 text-sm mt-6">
          ¿Tienes preguntas? Escríbenos a <a href="mailto:desactivate@kompa.global" className="text-yellow-500 hover:text-yellow-400">desactivate@kompa.global</a>
        </p>
      </div>
    </div>
  );
}
